import { render, staticRenderFns } from "./AddCardDialog.vue?vue&type=template&id=283f05ba&scoped=true"
import script from "./AddCardDialog.vue?vue&type=script&lang=js"
export * from "./AddCardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f05ba",
  null
  
)

export default component.exports